export default {
	dashboard: () => '/',
	integrations: {
		list: () => '/wallets',
	},
	reports: {
		list: () => '/reports',
	},
	transactions: {
		list: (query = '', hash = '') => `/transactions${query}${hash}`,
	},
	auth: {
		login: '/login',
		signUp: '/sign-up',
		authgrantRedirect: () => '/authgrant-redirect',
		onboarding: () => '/onboarding',
		acceptInvite: () => '/accept-invite',
		oauth: (provider = 'coinbase') => `/oauth/${provider}/authgrant_redirect`,
	},
	clients: {
		list: () => '/clients',
	},
	organization: () => '/organization',
	billings: {
		success: () => '/billings/success',
		cancel: () => '/billings/cancel',
	},
	external: {
		wealthica: 'https://app.wealthica.com/',
		wealthicaAddonDetails: 'https://app.wealthica.com/addons/details?id=blocksentry%2Fblocksentry',
	},
}
